module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABGdBTUEAALGPC/xhBQAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAAGlJREFUOE+tkzEKwDAMA/v/zwa6dHTx4DaOT8GUHmiRct5ymGBcw+yU84N+4fLnAyE3jvQObI7UhWSPoC4kR4DckjQHeFsSKAu5IWHNQm5ImAPUlsQIUFsSPQJefj+wQa8N2ZEvet/Z7AbZ1qLiz5kOlgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./ClientApp/images/node-icons/ce_supply-node.png
// module id = 978
// module chunks = 0